export const tippyIcons = {
    delete: `<svg viewBox="0 0 100 100"  xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="80" height="80" rx="10" ry="10" fill="#cccccc" />
            <text x="50" y="65" font-family="Arial" font-size="45" fill="#000000" text-anchor="middle">
                Del
            </text>
        </svg>`,
    rotate: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="80" height="80" rx="10" ry="10" fill="#cccccc" />
            <text x="50" y="70" font-family="Arial" font-size="60" fill="#000000" text-anchor="middle">
                R
            </text>
        </svg>`,
    edit: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="80" height="80" rx="10" ry="10" fill="#cccccc" />
            <text x="50" y="70" font-family="Arial" font-size="60" fill="#000000" text-anchor="middle">
                E
            </text>
        </svg>`,
    copy: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="80" height="80" rx="10" ry="10" fill="#cccccc" />
            <text x="50" y="70" font-family="Arial" font-size="60" fill="#000000" text-anchor="middle">
                C
            </text>
        </svg>`,
};
